import { render, staticRenderFns } from "./PatientEditor.vue?vue&type=template&id=549239a0&"
import script from "./PatientEditor.vue?vue&type=script&lang=js&"
export * from "./PatientEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports